import BaseService from './base.service'

class PromotionService extends BaseService {
    getById(promotionId) {
        return new Promise((resolve, reject) => {
            return this.request({ public: true })
                .post({
                    method: 'Promo.getById',
                    params: {
                        promoId: promotionId,
                    },
                })
                .then(response => resolve(response.data))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }

    getList() {
        return new Promise((resolve, reject) => {
            return this.request({ public: true }).post({
                method: 'Promo.getList',
            })
                .then(response => resolve(response.data))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }
}

export default new PromotionService()
